import React from "react";
import { Typography, Space } from "antd";

const { Title, Text } = Typography;

interface ConsultorFormHeaderProps {
  isDialog?: boolean;
  isEditing?: boolean;
}

export function ConsultorFormHeader({ isDialog = false, isEditing = false }: ConsultorFormHeaderProps) {
  return (
    <div
      style={{
        background: 'linear-gradient(90deg, #1d4ed8 0%, #1e3a8a 100%)',
        padding: '24px 32px',
        borderRadius: isDialog ? '8px' : '8px 8px 0 0',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
        marginBottom: isDialog ? '0' : '24px'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ marginBottom: '16px', flex: '1 1 0%' }}>
          <Title level={3} style={{ color: 'white', margin: 0 }}>
            {isEditing ? 'Editar Profissional' : 'Cadastro de Profissional'}
          </Title>
          <Text style={{ color: '#dbeafe', display: 'block', marginTop: '4px' }}>
            {isEditing ? 'Atualize os dados do profissional' : 'Preencha todos os dados do profissional'}
          </Text>
        </div>
        <img
          src="/uploads/logo-volper-branca.svg"
          alt="Volper Capital"
          style={{ height: '48px', maxWidth: '100%' }}
        />
      </div>
    </div>
  );
}